// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'check-badge';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m11.808 7.344-2.952 3.96c-.216.216-.504.288-.792.144 0 0-.072 0-.072-.072l-1.8-1.8' />
    <path d='M8.064 1.008C8.496.504 9.288.432 9.792.792l.216.216 1.152 1.44c.288.36.648.504 1.08.432l1.8-.216c.648-.072 1.296.432 1.368 1.08v.288l-.288 1.8c-.072.432.144.792.432 1.08l1.44 1.152c.504.432.576 1.224.216 1.728l-.216.216-1.44 1.152c-.36.288-.504.648-.432 1.08l.216 1.8c.072.648-.432 1.296-1.08 1.368h-.288l-1.8-.288c-.432-.072-.792.144-1.08.432l-1.152 1.44c-.432.504-1.224.576-1.728.216l-.216-.216-1.152-1.44c-.288-.36-.648-.504-1.08-.432l-1.8.216c-.648.072-1.296-.432-1.368-1.08v-.288l.288-1.8c.072-.432-.144-.792-.432-1.08l-1.44-1.152C.504 9.504.432 8.712.792 8.208l.216-.216 1.44-1.152c.288-.216.504-.576.432-1.008l-.216-1.8c-.072-.648.432-1.296 1.08-1.368h.288l1.8.216c.432 0 .792-.144 1.08-.432z' />
  </g>
);

export const viewBox = '0 0 18 18';
